import { ICreateFile, IUpdateFile } from "../../interfaces/File";

import { request } from "shared/utils";
import { METHODS, API } from "shared/constants";

export default {
  createFile: (params: ICreateFile) => request(METHODS.POST, API.CREATE_FILE)(params),
  updateFile: ({ id, ...rest }: IUpdateFile) => request(METHODS.PATCH, API.UPDATE_FILE(id))(rest),
};
